webpackJsonp([50840821570229],{

/***/ 355:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.md absPath of file >>> MarkdownRemark","html":"<h2>DMGT at a glance</h2>\n<p>DMGT manages a balanced multinational portfolio of entrepreneurial companies,\nwith total revenues of around £1.5 billion, that provide a diverse range of businesses\nand consumers with compelling information, analysis, insight, news and entertainment.</p>\n<p><img src=\"/img/dmgt-green-book-v9.pdf-page-6-of-56-2018-07-09-18-04-35.png\" alt=\"that alt text \"></p>\n<h2></h2>","frontmatter":{"date":"January 04, 2017","title":"Introduction","description":"Intro to DMG <no markup>","tags":["intro"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week-0298cafa5caf39e64a6e.js